import React, { useState } from 'react';
import { NavLink, Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAdminStore } from './adminStore';
import { FiGrid, FiPackage, FiTag, FiShoppingBag, FiUsers, FiLogOut, FiExternalLink, FiLayout, FiTruck, FiSettings, FiMessageSquare, FiMenu, FiX, FiGift, FiStar, FiTrendingUp } from 'react-icons/fi';
import './admin.css';

const nav = [
  { to: '/dashboard',  label: 'Dashboard',        Icon: FiGrid,        color: '#818cf8' },
  { to: '/store',      label: 'Manage Store',      Icon: FiLayout,      color: '#fb923c' },
  { to: '/products',      label: 'Manage Products',   Icon: FiPackage,     color: '#34d399' },
  { to: '/new-arrivals',  label: 'New Arrivals',      Icon: FiStar,        color: '#34d399' },
  { to: '/categories',    label: 'Manage Categories', Icon: FiTag,         color: '#60a5fa' },
  { to: '/orders',     label: 'Manage Orders',     Icon: FiShoppingBag, color: '#f472b6' },
  { to: '/courier',    label: 'Manage Courier',    Icon: FiTruck,       color: '#c084fc' },
  { to: '/reviews',     label: 'Manage Reviews',  Icon: FiMessageSquare, color: '#fbbf24' },
  { to: '/promotions',  label: 'Day Sale',      Icon: FiGift,        color: '#a78bfa' },
  { to: '/most-selling', label: 'Most Selling', Icon: FiTrendingUp,  color: '#f59e0b' },
  { to: '/settings',   label: 'Settings',        Icon: FiSettings,      color: '#f0b429' },
  { to: '/users',      label: 'Manage Users',        Icon: FiUsers,         color: '#2dd4bf' },
];

const TITLES = { '/dashboard':'Dashboard', '/store':'Manage Store', '/products':'Manage Products', '/new-arrivals':'New Arrivals', '/categories':'Manage Categories', '/orders':'Manage Orders', '/courier':'Manage Courier', '/reviews':'Manage Reviews', '/promotions':'Day Sale', '/most-selling':'Most Selling', '/settings':'Settings', '/users':'Manage Users' };

function AdminLayout() {
  const { logout } = useAdminStore();
  const navigate   = useNavigate();
  const { pathname } = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="admin-layout">
      {/* Mobile overlay */}
      {sidebarOpen && (
        <div className="admin-sidebar-overlay" onClick={() => setSidebarOpen(false)} />
      )}
      <aside className={`admin-sidebar${sidebarOpen ? ' open' : ''}`}>
        <div className="sidebar-brand">
          <div className="sidebar-brand-name">Seoul Station</div>
          <div className="sidebar-brand-sub">Admin Panel</div>
          <button className="sidebar-close-btn" onClick={() => setSidebarOpen(false)} aria-label="Close menu">
            <FiX size={18} />
          </button>
        </div>

        <nav className="sidebar-nav">
          <div className="sidebar-section-label">Main</div>
          {nav.map(item => (
            <NavLink
              key={item.to}
              to={item.to}
              style={{ '--c': item.color }}
              className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
              onClick={() => setSidebarOpen(false)}
            >
              <span className="snav-icon"><item.Icon size={15} /></span>
              <span className="snav-label">{item.label}</span>
            </NavLink>
          ))}
          <div className="sidebar-section-label">Links</div>
          <a href={process.env.REACT_APP_FRONTEND_URL || 'http://localhost:3000'} target="_blank" rel="noreferrer" className="sidebar-link" style={{ '--c': '#94a3b8' }}>
            <span className="snav-icon"><FiExternalLink size={15} /></span>
            <span className="snav-label">View Storefront</span>
          </a>
        </nav>

        <div className="sidebar-footer">
          <button className="sidebar-link" style={{ '--c': '#f87171' }} onClick={() => { logout(); navigate('/login'); }}>
            <span className="snav-icon"><FiLogOut size={15} /></span>
            <span className="snav-label">Logout</span>
          </button>
        </div>
      </aside>

      <div className="admin-content" style={(pathname === '/store' || pathname === '/courier') ? { display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' } : {}}>
        <div className="admin-topbar">
          <button className="admin-mobile-menu-btn" onClick={() => setSidebarOpen(o => !o)} aria-label="Toggle menu">
            <FiMenu size={20} />
          </button>
          <span className="admin-topbar-title">{TITLES[pathname] || 'Admin'}</span>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <div className="admin-user-chip">
              <div className="admin-user-avatar">A</div>
              Admin
            </div>
            <button
              onClick={() => { logout(); navigate('/login'); }}
              title="Logout"
              style={{
                display: 'flex', alignItems: 'center', gap: 6,
                padding: '7px 12px', border: '1.5px solid #fecaca',
                borderRadius: 8, background: '#fff1f2', color: '#dc2626',
                cursor: 'pointer', fontSize: '.8rem', fontWeight: 600,
                fontFamily: 'inherit', transition: 'all .15s',
              }}
              onMouseEnter={e => { e.currentTarget.style.background = '#fee2e2'; }}
              onMouseLeave={e => { e.currentTarget.style.background = '#fff1f2'; }}
            >
              <FiLogOut size={14} /> Logout
            </button>
          </div>
        </div>
        <div className={pathname === '/store' || pathname === '/courier' ? '' : 'admin-page'} style={(pathname === '/store' || pathname === '/courier') ? { flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' } : {}}>
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default AdminLayout;
